import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../../../config/site';
import { formatPrice } from '../../../utils/formatPrice';
import styles from './ProductInfo.module.css';

const DESCRIPTION_LIMIT = 200;
const phoneHref = `tel:${SITE.phone.replace(/\D/g, '')}`;

export function ProductInfo({ product }) {
  const [descExpanded, setDescExpanded] = useState(false);
  const [charsExpanded, setCharsExpanded] = useState(false);

  const description = product.description || product.full_name || '';
  const isLongDesc = description.length > DESCRIPTION_LIMIT;
  const displayDesc = descExpanded || !isLongDesc ? description : `${description.slice(0, DESCRIPTION_LIMIT)}…`;

  const characteristics = [
    product.article && { label: 'Артикул', value: product.article },
    product.quantity && { label: 'В наличии', value: `${Math.floor(parseFloat(product.quantity))} шт.` },
    ...(product.categories || []).map((cat) => ({
      label: 'Категория',
      value: cat.name,
      href: `/catalog?category=${cat.id}`,
    })),
  ].filter(Boolean);

  const visibleChars = charsExpanded ? characteristics : characteristics.slice(0, 3);

  return (
    <div className={styles.info}>
      <h1 className={styles.title}>{product.name}</h1>

      {product.price && <p className={styles.price}>{formatPrice(product.price)}</p>}

      {description && (
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>О товаре</h2>
          <p className={styles.text}>{displayDesc}</p>
          {isLongDesc && (
            <button
              type="button"
              className={styles.toggle}
              onClick={() => setDescExpanded(!descExpanded)}
            >
              {descExpanded ? 'Свернуть' : 'Подробнее'} {descExpanded ? '⌃' : '⌄'}
            </button>
          )}
        </section>
      )}

      {characteristics.length > 0 && (
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Характеристики</h2>
          <dl className={styles.chars}>
            {visibleChars.map((item) => (
              <div key={item.href || item.label + item.value} className={styles.charRow}>
                <dt>{item.label}</dt>
                <dd>
                  {item.href ? (
                    <Link to={item.href} className={styles.categoryLink}>
                      {item.value}
                    </Link>
                  ) : (
                    item.value
                  )}
                </dd>
              </div>
            ))}
          </dl>
          {characteristics.length > 3 && (
            <button
              type="button"
              className={styles.toggle}
              onClick={() => setCharsExpanded(!charsExpanded)}
            >
              {charsExpanded ? 'Свернуть' : 'Все характеристики'} {charsExpanded ? '⌃' : '⌄'}
            </button>
          )}
        </section>
      )}

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Как купить</h2>
        <p className={styles.text}>
          Товар можно купить в{' '}
          <Link to="/retail-store" className={styles.inlineLink}>
            розничном магазине
          </Link>{' '}
          по адресу{' '}
          <a
            href={SITE.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.inlineLink}
          >
            {SITE.address}
          </a>
          {' '}или оформить заказ на доставку в мессенджере MAX по телефону{' '}
          <a href={phoneHref} className={styles.inlineLink}>
            {SITE.phone}
          </a>
          . Подробнее о{' '}
          <Link to="/delivery" className={styles.inlineLink}>
            доставке
          </Link>
          .
        </p>
      </section>
    </div>
  );
}
